'use client';

import Link from 'next/link'
import { usePathname } from 'next/navigation'

interface BreadcrumbsProps {
  data?: {
    heading?: {
      title?: string
    }
  }
}

export default function Breadcrumbs({ data }: BreadcrumbsProps) {
  const pathname = usePathname()
  
  if (!pathname) return null;

  const paths = pathname.split('/').filter(Boolean)

  // Function to format path text
  const formatPathText = (path: string) => {
    // Remove any numbers and hyphens from the end of the path
    const cleanPath = path.replace(/-?\d+$/, '').replace(/-+$/, '')
    
    // Split by hyphens and format each word
    const formattedText = cleanPath.split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ')
    
    // Add ® symbol next to Botox
    if (formattedText.toLowerCase().includes('botox')) {
      return formattedText.replace(/botox/gi, 'Botox®')
    }
    
    return formattedText
  }

  return (
    <div className='Breadcrumbs w-full bg-neutral-200 py-6 md:py-12'>
      <div className='container'>
        <nav className='flex flex-wrap items-center gap-2'>
          <Link
            href='/'
            className='text-gray-slate hover:text-primary transition-colors'
          >
            Home
          </Link>
          {paths.map((path, index) => {
            const url = `/${paths.slice(0, index + 1).join('/')}`
            const formattedText = formatPathText(path)
            
            return (
              <div key={path} className='flex items-center gap-2'>
                <span className='text-gray-slate'>/</span>
                {index === paths.length - 1 ? (
                  <span className='text-gray-slate'>{formattedText}</span>
                ) : (
                  <Link
                    href={url}
                    className='text-gray-slate hover:text-primary transition-colors'
                  >
                    {formattedText}
                  </Link>
                )}
              </div>
            )
          })}
        </nav>
      </div>
    </div>
  )
}